import { attachmentConceptionFields } from './attachmentConceptionFields';

export const conceptionFields = {
    folderNumberOfConnection: null,
    newBuildingPermit: null,
    subsidizedWork: null,
    compliance: null,
    zac: null,
    roadConstruction: null,
    numberBuldingPermit: null,
    yearBulidingPermit: null,
    plotSurface: null,
    topsoilInGround: null,
    topsoilInSlab: null,
    simpleRoof: null,
    gravelledTerraceRoof: null,
    otherSurfaceType: null,
    activeSurface: null,
    observations: null,
    totalDisconnectionRainWater: null,
    partialDisconnectionRainWater: null,
    leakFlowRate: null,
    rateVolume: null,
    surfaceDisconnect: null,
    works: [],
    attachement: attachmentConceptionFields,
};
